// extracted by mini-css-extract-plugin
export var actionButton = "_a9-1";
export var actionButtons = "_a9-2";
export var actions = "_a9-0";
export var aiUnread = "_a9-10";
export var alignCenter = "_a9-h";
export var backWrapper = "_a9-3";
export var cellContainer = "_a9-4";
export var checkboxContainer = "_a9-5";
export var contentContainer = "_a9-6";
export var contentHeader = "_a9-8";
export var conversationsTableWrapper = "_a9-s";
export var draftReplyBadgeContainer = "_a9-m";
export var dropdownItem = "_a9-b";
export var dropdownItemsContainer = "_a9-a";
export var dropdownTitle = "_a9-c";
export var errorIcon = "_a9-7";
export var filter = "_a9-d";
export var gray = "_a9-i";
export var headerActionButtons = "_a9-e";
export var headerCheckboxContainer = "_a9-f";
export var icon = "_a9-j";
export var menuContainer = "_a9-k";
export var noMoreTicketsIcon = "_a9-12";
export var noMoreTicketsSubText = "_a9-13";
export var oneLine = "_a9-l";
export var optionsButton = "_a9-n";
export var plus = "_a9-o";
export var portalButtonsWrapper = "_a9-g";
export var red = "_a9-p";
export var scrolledTop = "_a9-9";
export var search = "_a9-q";
export var selectedConversationsCount = "_a9-r";
export var spinner = "_a9-t";
export var strong = "_a9-u";
export var summaryCell = "_a9-v";
export var tableContainer = "_a9-11";
export var tagContainer = "_a9-w";
export var threeDots = "_a9-x";
export var twoLines = "_a9-y";
export var unread = "_a9-z";